function sleep(delay: number) {
    return new Promise<any>(resolve => setTimeout(resolve, delay));
}

export default sleep;
